export function getNow() {
  return new Date().toLocaleString("es-CO", { timeZone: "America/Bogota" });
}
export function pad(n) { return String(n).padStart(2, "0"); }
export function getCurrentHour() {
  const now = new Date();
  return `${pad(now.getHours())}:00`;
}
export function getCurrentDate() {
  const now = new Date();
  return `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}`;
}

// Fecha + hora en formato militar (24h), sin depender del locale del
// navegador del usuario (que puede mostrar AM/PM por defecto).
export function formatFechaHora(dateInput) {
  if (!dateInput) return '—';
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '—';
  return d.toLocaleString('es-CO', { hour12: false });
}

// Para parámetros medidos (turbiedad, pH, cloro, color, temperatura) un
// registro sin ese dato debe quedar en `null`, no en 0 — un `0` es una
// lectura real (ej. "cero cloro residual", una alerta grave) y no se puede
// distinguir de "no se midió" si ambas cosas colapsan al mismo valor. Antes
// `|| 0` fundía los dos casos, lo que hacía que a Gráficos/Dashboard un hueco
// en los datos se les viera como una caída real a cero. Los campos de
// caudal/dosificación sí se quedan en 0 porque se usan en sumas (volúmenes,
// balance hídrico) donde `null` rompería la aritmética.
const numOrNull = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : null;
};

export const mapBackendToJSX = (r) => ({
  id: r.id,
  fecha: r.fecha,
  hora: r.horas,
  operario_id: r.encargado,
  operario: r.encargado_nombre,
  agua_cruda: {
    caudal_obispo: parseFloat(r.agua_cruda?.caudal_obispo) || 0,
    caudal_palmichala: parseFloat(r.agua_cruda?.caudal_palmichala) || 0,
    caudal_total: parseFloat(r.agua_cruda?.caudal_total) || 0,
    turbiedad: numOrNull(r.agua_cruda?.turbiedad),
    color_upc: numOrNull(r.agua_cruda?.color_upc),
    ph: numOrNull(r.agua_cruda?.ph),
    temperatura: numOrNull(r.agua_cruda?.temperatura),
    dosis_coagulante: parseFloat(r.agua_cruda?.dosis_coagulante) || 0,
  },
  agua_tratada: {
    turbiedad: numOrNull(r.agua_tratada?.turbiedad),
    color_upc: numOrNull(r.agua_tratada?.color_upc),
    ph: numOrNull(r.agua_tratada?.ph),
    cloro_libre: numOrNull(r.agua_tratada?.cloro_residual_libre),
    cloro_total: numOrNull(r.agua_tratada?.cloro_residual_total),
    temperatura: numOrNull(r.agua_tratada?.temperatura),
    dosis_cloro: parseFloat(r.agua_tratada?.dosisCloro) || 0,
    dosis_hipoclorito: parseFloat(r.agua_tratada?.dosisHipoclorito) || 0,
  },
  macros: {
    lectura_6: parseFloat(r.macros?.lectura_seis) || 0,
    lectura_2: parseFloat(r.macros?.lectura_dos) || 0
  },
  caudal_macros: {
    lectura_6: parseFloat(r.caudal?.lectura_seis) || 0,
    lectura_2: parseFloat(r.caudal?.lectura_dos) || 0
  },
  // Clima capturado por el servidor al crear el registro (no se setea al
  // editar). Queda en null si no había coordenadas configuradas o falló la
  // consulta a Open-Meteo en ese momento — ver RegistroDiarioSerializer.create.
  clima: {
    temperatura: numOrNull(r.clima_temperatura),
    precipitacion_mm: numOrNull(r.clima_precipitacion_mm),
    codigo: numOrNull(r.clima_codigo),
  },
  observaciones: r.observaciones || ""
});

export const mapUserToJSX = (u) => {
  let rol = "operario";
  if (u.is_superuser) {
    rol = "administrador_ti";
  } else if (u.is_staff) {
    rol = "administrador";
  }
  return {
    id: u.id,
    username: u.username,
    nombre: (u.first_name + " " + u.last_name).trim() || u.username,
    rol: rol,
    email: u.email,
    activo: u.is_active,
    creado: u.date_joined ? u.date_joined.split('T')[0] : ""
  };
};

export const mapJSXToBackend = (r) => ({
  fecha: r.fecha,
  horas: r.hora,
  encargado: r.operario_id,
  agua_cruda: {
    caudal_obispo: r.agua_cruda.caudal_obispo,
    caudal_palmichala: r.agua_cruda.caudal_palmichala,
    caudal_total: r.agua_cruda.caudal_total,
    turbiedad: r.agua_cruda.turbiedad,
    color_upc: r.agua_cruda.color_upc,
    ph: r.agua_cruda.ph,
    temperatura: r.agua_cruda.temperatura,
    dosis_coagulante: r.agua_cruda.dosis_coagulante,
  },
  agua_tratada: {
    turbiedad: r.agua_tratada.turbiedad,
    color_upc: r.agua_tratada.color_upc,
    ph: r.agua_tratada.ph,
    cloro_residual_libre: r.agua_tratada.cloro_libre,
    cloro_residual_total: r.agua_tratada.cloro_total,
    temperatura: r.agua_tratada.temperatura,
    dosisCloro: r.agua_tratada.dosis_cloro,
    dosisHipoclorito: r.agua_tratada.dosis_hipoclorito,
  },
  macros: {
    lectura_seis: r.macros.lectura_6,
    lectura_dos: r.macros.lectura_2
  },
  caudal: {
    lectura_seis: r.caudal_macros?.lectura_6 !== undefined && r.caudal_macros?.lectura_6 !== null ? Number(parseFloat(r.caudal_macros.lectura_6).toFixed(4)) : 0,
    lectura_dos: r.caudal_macros?.lectura_2 !== undefined && r.caudal_macros?.lectura_2 !== null ? Number(parseFloat(r.caudal_macros.lectura_2).toFixed(4)) : 0
  },
  observaciones: r.observaciones
});
